import {
    Marker,
    useMap,
    useMapEvents
} from 'react-leaflet';

import { useState } from 'react';

import { usePontosOperacionais } from '../../hooks/pontosOperacionais/usePontosOperacionais';
import { createPointIcon } from '../../utils/map/createPointIcon';

export default function MapPontosOperacionais() {

    const map = useMap();

    const [zoom, setZoom] = useState(
        map.getZoom()
    );

    useMapEvents({
        zoomend: () => {
            setZoom(
                map.getZoom()
            );
        }
    });

    const pontosOperacionais = usePontosOperacionais();

    return (
        <>
            {pontosOperacionais.map(ponto => {

                const latitude =
                    Number(ponto.LATITUDE);

                const longitude =
                    Number(ponto.LONGITUDE);

                if (
                    !Number.isFinite(latitude) ||
                    !Number.isFinite(longitude)
                ) {
                    return null;
                }

                return (
                    <Marker
                        key={ponto.ID}
                        position={[
                            latitude,
                            longitude
                        ]}
                        icon={
                            createPointIcon(
                                'operational',
                                {
                                    label: ponto.NOME,
                                    zoom
                                }
                            )
                        }
                        interactive={false}
                    />
                );
            })}
        </>
    );
}